
































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Checkbox, TextInput, Button } from '@alpha/ink'
import store from '@/store'
import api from '@/api'

@Component({
  components: {
    Checkbox,
    TextInput,
    Button
  }
})

export default class Login extends Vue {
  @Prop({ default: '' }) initialMessage!: string
  authType: 'password' | 'saml' = 'password' // TODO Move to store
  email: string = ''
  processing: boolean = false
  password: string = ''
  loginError: string | false = false
  rememberMe: boolean = false
  passwordHidden: boolean = true

  toggleMode () {
    this.$emit('toggleMode')
  }

  toggleAuthType () {
    this.loginError = false
    if (this.authType === 'password') {
      this.authType = 'saml'
    } else {
      this.authType = 'password'
    }
  }

  togglePasswordHidden () {
    this.passwordHidden = !this.passwordHidden
  }

  handleFormKeypress (e: KeyboardEvent) {
    e.stopPropagation()
    if (e.key === 'Enter') {
      e.preventDefault()
      this.submit()
    }
  }

  validateEmail (email: string): boolean {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
  }

  async submit () {
    if (this.processing) return
    this.loginError = false
    if (!this.email || !this.email.trim() || !this.validateEmail(this.email)) {
      this.loginError = 'Please enter a valid email address.'
      return
    }

    if (this.authType === 'password' && (!this.password || !this.password.trim())) {
      this.loginError = 'A password is required.'
      return
    }

    this.processing = true

    if (this.authType === 'saml') {
      try {
        const res = await api.loginSaml(this.email)
        if (res.data.next) {
          window.location.href = res.data.next
        } else {
          this.processing = false
          this.loginError = res.data.msg
        }
      } catch (err) {
        this.loginError = err.response ? err.response.data : 'Failed to connect'
      }
    } else {
      try {
        await store.dispatch.user.login({
          auth_type: this.authType,
          email: this.email,
          password: this.password
        })
        const incomingUrl = this.$route.params.continue
        const path = incomingUrl || '/'
        this.$router.push(path)
      } catch (err) {
        this.loginError = err.response ? err.response.data : 'Failed to connect'
      }
    }
    this.processing = false
  }
}
